import hateoas from 'viralstyle-ui/src/hateoas';

export const getCustomerOrders = async ({ rootState, state, dispatch, commit }, lazy) => {
  if (!state.orders.initialized || lazy) {
    let response = await dispatch('get', `${rootState.checkout.customer._links.get_orders.href}?page=${state.orders.page}&limit=${state.orders.limit}&sort=created_at:DESC`);

    commit('updatePaginatableCollection', { collectionObject: state.orders, data: response.data });

    return response;
  }
};

export const validateRegisterEmail = ({ dispatch }, email) => {
  return dispatch('get', `${hateoas.url('check_email_exists')}?email=${email}`)
};

export const validatePublicName = ({ dispatch }, publicName) => {
  return dispatch('get', hateoas.url('validate_public_name', { publicName }));
};

export const register = async ({ rootState, state, dispatch }, payload) => {
  let apiUrl = rootState.route.query.pid && state.partnerInfo ? state.partnerInfo.links.register_client.href : hateoas.url('register'),
    response = await dispatch('post', { apiUrl, payload });

  dispatch('eventRegister');

  response = await dispatch('getUserInfo');

  return response;
};

export const forgotPassword = ({ dispatch }, { email, token }) => {
  return dispatch('post', { apiUrl: hateoas.url('request_reset_password'), payload: { email_address: email, token } });
};

export const resetPassword = ({ dispatch }, { password, token }) => {
  return dispatch('post', {
    apiUrl: hateoas.url('reset_password'),
    payload: {
      password,
      token
    },
  });
};

export const getPartnerInfo = async ({ rootState, dispatch, commit }) => {
  let response = await dispatch('get', hateoas.url('get_cobrand_configs', { cobrandIdHash: rootState.route.query.pid }));

  commit('setPartnerInfo', response.data);

  return response;
};